import Request from '../modules/request.js'

const createTag = (name, id, class_name) => {

  let tag = document.createElement(name);
  tag.id = id;
  tag.className = class_name;
  return tag;
}

const setDataContent = (code, data) => {
  console.log(`O CODIGO DE RESPOSTA É: ${code}`);

  if (code == 200) {
    document.getElementById('data-content').innerHTML = data;

  }
  if (code == 401) {
    console.log(code);

  }
}

const showNotify = (data, autoremove = false) => {
  if (document.getElementById('notify')) {
    document.getElementById('notify').remove();
  }
  let div = document.createElement('div');
  div.id = 'notify';
  div.className = 'notify';
  let span = document.createElement('span');
  span.innerHTML = data.message;
  div.append(span);
  document.body.append(div);
  if (autoremove) {
    setTimeout(() => {
      document.getElementById('notify').remove();
    }, 3500);
  }
}

let idWidth = null;

export default class User {
    constructor() {
      this.createdmenu = false;
      this.last_user_marked = null;
      this.formArchives = null;
      this.filesUp = null;
    }
    openSettings(user_id, last_updated, redirect = '/dashboard/logout') {
      if (this.createdmenu) {
        document.getElementById('acc-options').remove();
        this.createdmenu = false;
        return;
      }
      this.createdmenu = true;
      let div = createTag('div', 'acc-options', 'account-float');
      let row = this.line('USERID:', user_id);
      let row2= this.line('UPDATED:', last_updated);

      let link = createTag('a');
      link.href = `/dashboard/current-user/${user_id}/settings`
      link.innerHTML = 'Gerenciar conta';

      let linkLogout = createTag('a');
      linkLogout.href = `${redirect}`;
      linkLogout.innerHTML = 'Sair';

      div.append(link);
      div.append(row);
      div.append(row2);
      div.append(linkLogout);
      document.body.append(div);
    }

    line(name, value, class_name='') {
      let row = createTag('div', 'acc-1', 'flex normal-wrap btwen');
      let strong = createTag('span', '', class_name);
      strong.innerHTML = name;
      let span = createTag('span', '', class_name);
      span.innerHTML = value;
      row.append(strong);
      row.append(span);
      return row;
    }

    sendMailToken(url) {
      let token = document.getElementById('user_email_token').value;
      let auth_token = document.getElementsByName('authenticity_token')[0].value;

      if (token.length == 6) {
        let params = `authenticity_token=${auth_token}&user[mail_token]=${token}`;
        const request = new Request();
        request.post(url, params, (request, response) => {
          // let data = JSON.parse(response.data);
          Notify.delivery(response.data);
        });
      } else {
        console.log('no token');
      }

    }

    select(user_id) {
      let user_field = document.getElementById('authorization_user_id');
      user_field.value = user_id;

      if (this.last_user_marked != null) {
        this.last_user_marked.classList.remove('marked');
        this.last_user_marked.lastElementChild.firstElementChild.classList.remove('green');
        this.last_user_marked.lastElementChild.firstElementChild.classList.add('dark');
      }

      let userSelect = document.getElementById(`u-${user_id}`);
      userSelect.classList.add('marked');
      userSelect.lastElementChild.firstElementChild.classList.remove('dark');
      userSelect.lastElementChild.firstElementChild.classList.add('green');
      this.last_user_marked = userSelect;
    }

    // client user -> dashboard
    openSystem(url) {
      window.location.href = url;
    }

    getNewFilePage(url) {
      Dashboard.setCurrentPage('archives');
      const request = new Request();
      request.get(url, (request, response) => {
        setDataContent(response.statusCode, response.data);
      });
    }

    // cria folder ui
    createUiFolder(name) {
      let file = document.createElement('span');
      file.innerHTML = name;
      document.getElementById('selected-files').append(file);
      document.getElementById('archive-submit-upload').removeAttribute('disabled');
    }

    uploaderHandler(e) {
      let files = e.target.files;
      this.inputFilesName = e.target.name;
      this.filesUp = files;
      document.getElementById('selected-files').innerHTML = '';
      for (let file of files) {
        this.createUiFolder(file.name);
      }
    }

    progressView(progress = 0, message = 'Aguarde') {
      const view = document.getElementById('progress-upload-view');
      const progressView = document.getElementById('progress-view');
      const percent = document.getElementById('percent-upload');
      const textProgress = document.getElementById('text-progress');
      view.style.display = 'block';
      if (progress == 100) {
        clearInterval(idWidth);
        percent.innerHTML = `${progress}%`;
        progressView.style.width = `${progress - 10}%`;
        textProgress.innerHTML = message;
        setTimeout(() => {
          view.style.display = 'none';
          textProgress.innerHTML = 'Aguarde';
          progressView.style.width = `${0}%`;
        }, 2500);
        return 1;
      }
      let width = 0;
      idWidth = setInterval(() => {
        width++;
        percent.innerHTML = `${width}%`;
        progressView.style.width = `${width - 10}%`;
        if (width >= 89) {
          clearInterval(idWidth);
        }
      }, 100);
    }

    submitFiles(url) {
      console.log('submit files');
      const bsub = document.querySelector('#archive-submit-upload');
      bsub.disabled=true;
      let form = document.getElementById('form');
      const formData = new FormData(form);

      const data = {message: 'Aguarde', created: true}
      // showNotify(data)
      this.progressView();
      fetch(form.action, {
        method: 'POST',
        headers: {
          'X-CSRF-Token': document.querySelector('meta[name="csrf-token"]').content
        },
        body: formData
      })
      .then(response => response.json())
      .then(data => {
        console.log(data);
        this.progressView(100, 'Concluido');
        showNotify(data, true, data.redirect);
      })
      .catch(error => {
        const info = {message: 'Error, check logs for details', created: true}
        showNotify(info)
        console.error('Error:', error)
        this.progressView(98, 'Error');
        Pmdsl.navigator('archives', data.redirect);
      });
    }
}
